module.exports = __webpack_public_path__ + "static/researchers-82931eb3e312cbdec44fe2ae1c2747dd.png";